import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ApplicationComponent } from './application/application.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { QuoteComponent } from './quote/quote.component';
import { CostOfLivingComponent } from './dialogs/cost-of-living/cost-of-living.component';
import { InfectiousDiseaseComponent } from './dialogs/infectious-disease/infectious-disease.component';
import { ExtendedEarningsComponent } from './dialogs/extended-earnings/extended-earnings.component';
import { StudentLoanRepaymentComponent } from './dialogs/student-loan-repayment/student-loan-repayment.component';
import { LiabilityPremiumComponent } from './dialogs/liability-premium/liability-premium.component';
import { RetirementContributionComponent } from './dialogs/retirement-contribution/retirement-contribution.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { PaymentComponent } from './payment/payment.component';
import { SignComponent } from './sign/sign.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { SignAndSubmitComponent } from './dialogs/sign-and-submit/sign-and-submit.component';
import { SecureHttp } from './helpers/securehttp';
import {MatRadioModule} from '@angular/material/radio';
import {MatMenuModule} from '@angular/material/menu';
import { AuthService } from './services/auth.service';
import { MGISConstants } from './constants/mgis.constants';
import { PhoneNumberFormatterDirective } from './directives/phone-number-formatter.directive';
import { StripeService } from './services/stripe.service';
import { PaymentsService } from './services/payments.service';
import { LastFourPipe } from './pipes/last-four.pipe';
import { TitleCasePipe } from '@angular/common';
import { NgxStripeModule } from 'ngx-stripe';
import { ConfigService } from './services/config.service';
import { BankAccountsService } from './services/bank-accounts.service';
import { IpAddressService } from './services/ip-address.service';
import { FinalPageComponent } from './final-page/final-page.component';
import { WhatIsHLDInsuranceComponent } from './dialogs/what-is-hld-insurance/what-is-hld-insurance.component';
import { DefineHLDInsuranceComponent } from './dialogs/define-hld-insurance/define-hld-insurance.component';
import { NotQualifiedComponent } from './dialogs/not-qualified/not-qualified.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    ApplicationComponent,
    QuoteComponent,
    CostOfLivingComponent,
    WhatIsHLDInsuranceComponent,
    DefineHLDInsuranceComponent,
    NotQualifiedComponent,
    InfectiousDiseaseComponent,
    ExtendedEarningsComponent,
    StudentLoanRepaymentComponent,
    LiabilityPremiumComponent,
    RetirementContributionComponent,
    QuestionnaireComponent,
    PaymentComponent,
    SignComponent,
    SignAndSubmitComponent,
    PhoneNumberFormatterDirective,
    FinalPageComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    MatSnackBarModule,
    NgbModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule,
    MatRadioModule,
    MatMenuModule,
    NgxStripeModule.forRoot(),
  ],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    provideNativeDateAdapter(),
    AuthService,
    MGISConstants,
    SecureHttp,
    StripeService,
    PaymentsService,
    LastFourPipe,
    TitleCasePipe,
    ConfigService,
    BankAccountsService,
    IpAddressService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
